export default __webpack_public_path__ + "550c68e705a0116c6c3f05a1ca50f8eb.svg";